module.exports = __webpack_public_path__ + "static/7-2c48e67e83aea2509621ea7208eb30fe.webp";